import GalleryModal from 'components/gallery-modal/gallery-modal/GalleryModal';

export const WITH_GALLERY_MODAL_CONFIG = {
  modalContent: GalleryModal,
  closeIconPosition: 'corner',
  closeIconType: 'fancy',
  closeOnOverlayClick: true,
  shouldListenToEsc: true
};
